/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Funnel_Stage_RejectedInputs */

const en_analytics_funnel_stage_rejected = /** @type {(inputs: Analytics_Funnel_Stage_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejected`)
};

const de_analytics_funnel_stage_rejected = /** @type {(inputs: Analytics_Funnel_Stage_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abgelehnt`)
};

const fr_analytics_funnel_stage_rejected = /** @type {(inputs: Analytics_Funnel_Stage_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refusé`)
};

const es_analytics_funnel_stage_rejected = /** @type {(inputs: Analytics_Funnel_Stage_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechazado`)
};

const it_analytics_funnel_stage_rejected = /** @type {(inputs: Analytics_Funnel_Stage_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rifiutata`)
};

const nl_analytics_funnel_stage_rejected = /** @type {(inputs: Analytics_Funnel_Stage_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afgewezen`)
};

const pl_analytics_funnel_stage_rejected = /** @type {(inputs: Analytics_Funnel_Stage_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odrzucono`)
};

const fi_analytics_funnel_stage_rejected = /** @type {(inputs: Analytics_Funnel_Stage_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hylätty`)
};

const da_analytics_funnel_stage_rejected = /** @type {(inputs: Analytics_Funnel_Stage_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afvist`)
};

const sv_analytics_funnel_stage_rejected = /** @type {(inputs: Analytics_Funnel_Stage_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvisad`)
};

/**
* | output |
* | --- |
* | "Rejected" |
*
* @param {Analytics_Funnel_Stage_RejectedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_funnel_stage_rejected = /** @type {((inputs?: Analytics_Funnel_Stage_RejectedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Funnel_Stage_RejectedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_funnel_stage_rejected(inputs)
	if (locale === "fr") return fr_analytics_funnel_stage_rejected(inputs)
	if (locale === "es") return es_analytics_funnel_stage_rejected(inputs)
	if (locale === "it") return it_analytics_funnel_stage_rejected(inputs)
	if (locale === "nl") return nl_analytics_funnel_stage_rejected(inputs)
	if (locale === "pl") return pl_analytics_funnel_stage_rejected(inputs)
	if (locale === "fi") return fi_analytics_funnel_stage_rejected(inputs)
	if (locale === "da") return da_analytics_funnel_stage_rejected(inputs)
	if (locale === "sv") return sv_analytics_funnel_stage_rejected(inputs)
	return en_analytics_funnel_stage_rejected(inputs)
});